import {html, css, LitElement} from 'lit';

export class DzMultiSelect extends LitElement {

    static get properties() {
        return {
            choosed: { type: Boolean, reflect: true }
        }
    }


    constructor() {
        super()
        this.selected = []
        this.choosed = false
        this.has_initial = false
    }

    connectedCallback() {
        super.connectedCallback()
        this.addEventListener("select", evt => {
            if (evt.initial) {
                this.has_initial = true
            }
            this.selected.push(evt.target)
            this.choosed = true
        })

        this.addEventListener("deselect", evt => {
            this.selected = this.selected.filter(item => item !== evt.target)
            if (this.selected.length == 0) {
                this.choosed = false
                evt.lastDeselect = true
            }
        })

        this.addEventListener("reset", this.reset)
    }

    reset(evt) {
        for (let item of this.selected) {
            item.deselect()
        }
        this.choosed = false
        if (!this.has_initial) {
            evt.stopPropagation()
        }
    }

    render() {
        return html`
           <slot></slot>
        `
    }
}

customElements.define('dz-multi-select', DzMultiSelect)